<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column5">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column7">
				<form class="newsletter">
					<input type="text" :placeholder="$t('formEmail')" />
					<input type="submit" class="button" :value="button" />
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 75px 0;
	background: var(--dark-background-color);
	color: var(--body-color);

	h2,
	div {
		color: #fff;
	}

	form {
		margin-top: 30px;
		display: flex;
		flex-flow: row wrap;
		justify-content: center;
		align-items: center;
		gap: 20px;

		input {
			background: none;
			padding: 15px 15px 15px 0;
			height: 52px;
			border: none;
			border-bottom: 1px solid #fff;
			color: #fff;
			width: 48%;
			max-width: 300px;
			font-size: var(--body-font-size);
			vertical-align: top;

			&::placeholder {
				color: #fff;
			}

			&.button {
				line-height: 22px;
				color: var(--cta-color);
				background: #fff;
				max-width: 200px;
				padding: 15px;
				cursor: pointer;
				border: none;

				&:hover {
					background: var(--cta-color-hover);
					color: #fff;
				}
			}
		}
	}
}

@media (max-width: 1080px) {
	.newsletter-section {
		.columns {
			width: 100%;
			text-align: center;
		}
	}
}

@media (max-width: 580px) {
	.newsletter-section {
		padding: 60px 15px;

		form {
			input {
				width: 100%;
				max-width: 100%;

				&.button {
					max-width: 100%;
				}
			}
		}
	}
}
</style>
